import { render } from "./button.html?vue&type=template&id=2ae39520&scoped=true&external"
import script from "./button.ts?vue&type=script&lang=js&external"
export * from "./button.ts?vue&type=script&lang=js&external"

import "./button.scss?vue&type=style&index=0&id=2ae39520&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae39520"],['__file',"src/components/ui/button/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ae39520"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ae39520', __exports__)) {
    api.reload('2ae39520', __exports__)
  }
  
  module.hot.accept("./button.html?vue&type=template&id=2ae39520&scoped=true&external", () => {
    api.rerender('2ae39520', render)
  })

}


export default __exports__